import React from 'react';
import {Tag} from 'antd';

const columnDefines = () => ({
    handoverUser: {
        title: '交接人',
        dataIndex: 'handoverUser',
        render: handoverUser => handoverUser.name + '(' + handoverUser.extId + ')',
    },
    takeoverUser: {
        title: '接收人',
        dataIndex: 'takeoverUser',
        render: takeoverUser => takeoverUser.name + '(' + takeoverUser.extId + ')',
    },
    takeoverTime: {
        title: '移交时间',
        dataIndex: 'takeoverTime',
    },
    status: {
        title: '交接状态',
        dataIndex: 'status',
        render: status => switchTag(status),
    },
    errorCode: {
        title: '错误码',
        dataIndex: 'errorCode',
        render: errorCode =>
            errorCode === 0 ? (
                <Tag color="green">无错误码</Tag>
            ) : (
                <Tag color="red">
                    <a
                        style={{color: 'red'}}
                        href={'https://open.work.weixin.qq.com/devtool/query?e=' + errorCode}
                        target="_blank"
                    >
                        {errorCode}
                    </a>
                </Tag>
            ),
    },
});

function switchTag(status) {
    status = parseInt(status, 10);
    let temp;
    // 1-接替完毕 2-等待接替 3-客户拒绝 4-接替成员客户达到上限 5-无接替记录
    switch (status) {
        case 0:
            temp = <Tag color="red">交接失败</Tag>;
            break;
        case 1:
            temp = <Tag color="green">交接完毕</Tag>;
            break;
        case 2:
            temp = <Tag color="cyan">等待交接</Tag>;
            break;
        case 3:
            temp = <Tag color="magenta">客户拒绝</Tag>;
            break;
        case 4:
            temp = <Tag color="purple">>接替成员客户达到上限</Tag>;
            break;
        case 5:
            temp = <Tag>无接替记录</Tag>;
            break;
    }
    return temp;
}

export function getColumns(keys) {
    const defines = columnDefines();
    return keys.map(key => defines[key]).filter(Boolean);
}
